import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useConfigVendas from '../hooks/useConfigVendas';

// Redireciona para /inicio/dashboard (com aviso) se a flag do modulo estiver
// desligada. Antes ia para /inicio, que nao e rota e caia no 404.
// flag: 'contratoAtivo' | 'ordemServicoAtivo' | 'pdvAtivo' | 'vendaRapidaAtivo'
//
// Aguarda `loaded` antes de decidir redirect — evita "flash" para /inicio
// quando o usuario chega via deep link e o context ainda nao terminou
// a primeira chamada de /v1/configs/all.
const AVISOS = {
  contratoAtivo: 'Contratos está desativado em Configurações de Vendas.',
  ordemServicoAtivo: 'Ordem de Serviço está desativada em Configurações de Vendas.',
  pdvAtivo: 'O PDV está desativado em Configurações de Vendas.',
  vendaRapidaAtivo: 'Venda Rápida está desativada em Configurações de Vendas.',
};

const RedirecionaDesativado = ({ flag }) => {
  useEffect(() => {
    // toastId fixo: StrictMode/re-render nao empilha o mesmo aviso.
    toast.info(AVISOS[flag], {
      toastId: `config-vendas-guard-${flag}`,
    });
  }, [flag]);
  return <Navigate to="/inicio/dashboard" replace />;
};

RedirecionaDesativado.propTypes = {
  flag: PropTypes.string.isRequired,
};

const ConfigVendasGuard = ({ flag, children }) => {
  const config = useConfigVendas();
  if (!config.loaded) {
    return null;
  }
  if (!config[flag]) {
    return <RedirecionaDesativado flag={flag} />;
  }
  return children;
};

ConfigVendasGuard.propTypes = {
  flag: PropTypes.oneOf(['contratoAtivo', 'ordemServicoAtivo', 'pdvAtivo', 'vendaRapidaAtivo']).isRequired,
  children: PropTypes.node.isRequired,
};

export default ConfigVendasGuard;
